import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Component } from 'react';
import cn from 'classnames/bind';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
class ElementContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: props.active,
        };
    }
    onFocus = () => {
        this.setState({ active: true });
    };
    onBlur = () => {
        this.setState({ active: false });
    };
    static getDerivedStateFromProps(props, state) {
        return {
            active: props.active !== undefined ? props.active : state.active,
        };
    }
    render() {
        const { disabled, children, icon, hasError } = this.props;
        const { active } = this.state;
        const withIcon = !!icon;
        return (jsx("div", { className: cx({
                container: true,
                active,
                disabled,
                withIcon,
                hasError,
            }), onFocus: this.onFocus, onBlur: this.onBlur, children: icon ? (jsxs(Fragment, { children: [jsx("div", { className: cx('icon'), children: icon }), jsx("div", { className: cx('elementWithIcon'), children: children })] })) : (children) }));
    }
}

export { ElementContainer as default };
//# sourceMappingURL=index.js.map
